import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'

export default function KindFetch () {
  const [kinds, setKinds] = useState([])
  const [error, setError] = useState(false)

  const getKinds = useCallback(async () => {
    try {
      let url = '/kinds?page=1&limit=1000'
      const res = await axios.get(url)
      let newKinds = (res.data.kinds || []).map(
        (kind) => ({
          id: kind._id,
          title: kind.title,
          type: kind.type
        })
      )
      setKinds(newKinds)
    } catch (err) {
      setError(err)
    }
  }, [])

  useEffect(() => {
    getKinds()
  }, [getKinds])

  return { kinds, error }
}
